import React from 'react';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { Provider } from 'react-redux';
import { store } from '@src/store/reduxStore';
import FaqContent from './FaqContent';

const includeBaseCss = false;

const FaqContentComponent = (props: any) => {
  const theme: any = createTheme('uhc', {
    deprecatedFont: true,
  });
  theme.themeVariantFonts();

  return (
    <ThemeProvider theme={theme} includeBaseCss={includeBaseCss}>
      <OverlayProvider>
        <Provider store={store}>
          <FaqContent />
        </Provider>
      </OverlayProvider>
    </ThemeProvider>
  );
};

export default FaqContentComponent;
